import React from "react";
import Dashboard from "./component/sections/Dashboard";

function App() {
  return <Dashboard />;
}

export default App;
